/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Share_CopiedInputs */



/**
* | output |
* | --- |
* | "Event link copied to clipboard" |
*
* @param {Tournament_Share_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_share_copied = /** @type {((inputs?: Tournament_Share_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Share_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lien de l'événement copié dans le presse-papier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlace del evento copiado al portapapeles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Link do evento copiado para a área de transferência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Link dell'evento copiato negli appunti")
	return /** @type {LocalizedString} */ ("Event link copied to clipboard")
});